module.exports = __webpack_public_path__ + "static/media/silver2.911f247f.jpg";